import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { compose, withProps } from 'recompose';
import AddressFooter from '../../shared/AddressFooter';
import withMembershipAgreement from '../../hoc/withMembershipAgreement';

const MembershipAgreement = ({ brandLogo, agreement }) => (
  <div>
    <div className="c-membership-wrapper">
      <div className="c-membership-header">
        <img src={brandLogo} className="c-brand-logo u-mb-8" alt="logo" />
        <h2 className="c-membership-title">Your membership Terms & Conditions</h2>
      </div>
      <div className="c-membership-text">
        <p>{agreement}</p>
      </div>
    </div>
    <AddressFooter />
  </div>
);

MembershipAgreement.propTypes = {
  brandLogo: PropTypes.string.isRequired,
  agreement: PropTypes.string.isRequired,
};

export default compose(
  withRouter,
  withMembershipAgreement,
  withProps(props => ({
    brandLogo: props.location.query.brandLogo,
  })),
)(MembershipAgreement);



// WEBPACK FOOTER //
// ./src/app/notifications/membership/MembershipAgreement/index.jsx